import {useCallback, useEffect, useState} from "react";

import {conversationalSearchResponseRatedHit} from "../tracking/conversational_search_response_rated_hit";

const STORAGE_KEY = "semantic_search_property_votes";

type VoteType = "like" | "dislike" | null;

interface IPropertyVote {
    propertyId: number;
    vote: "like" | "dislike";
}

const getStoredVotes = (): IPropertyVote[] => {
    if (typeof window === "undefined") return [];

    const stored = localStorage.getItem(STORAGE_KEY);

    if (!stored) return [];

    try {
        return JSON.parse(stored);
    } catch {
        return [];
    }
};

const saveVotes = (votes: IPropertyVote[]): void => {
    if (typeof window === "undefined") return;

    localStorage.setItem(STORAGE_KEY, JSON.stringify(votes));
};

export const usePropertyVote = (propertyId: number, apiMessageIndex: number) => {
    const [currentVote, setCurrentVote] = useState<VoteType>(() => {
        const votes = getStoredVotes();
        const found = votes.find((v) => v.propertyId === propertyId);

        return found?.vote ?? null;
    });

    const handleVote = useCallback(
        (vote: "like" | "dislike") => {
            const votes = getStoredVotes();
            const index = votes.findIndex((v) => v.propertyId === propertyId);

            let finalVote: "like" | "dislike" | null = vote;

            if (index !== -1) {
                if (votes[index].vote === vote) {
                    votes.splice(index, 1);

                    setCurrentVote(null);
                    finalVote = null;
                } else {
                    votes[index].vote = vote;

                    setCurrentVote(vote);
                }
            } else {
                votes.push({propertyId, vote});

                setCurrentVote(vote);
            }

            saveVotes(votes);

            conversationalSearchResponseRatedHit(propertyId, finalVote, apiMessageIndex);
        },

        [propertyId, apiMessageIndex]
    );

    useEffect(() => {
        const votes = getStoredVotes();
        const found = votes.find((v) => v.propertyId === propertyId);

        setCurrentVote(found?.vote ?? null);
    }, [propertyId]);

    return {currentVote, handleVote};
};
import {useCallback, useEffect, useState} from "react";

import {conversationalSearchResponseRatedHit} from "../tracking/conversational_search_response_rated_hit";

const STORAGE_KEY = "semantic_search_property_votes";

type VoteType = "like" | "dislike" | null;

interface IPropertyVote {
    propertyId: number;
    vote: "like" | "dislike";
}

const getStoredVotes = (): IPropertyVote[] => {
    if (typeof window === "undefined") return [];

    const stored = localStorage.getItem(STORAGE_KEY);

    if (!stored) return [];

    try {
        return JSON.parse(stored);
    } catch {
        return [];
    }
};

const saveVotes = (votes: IPropertyVote[]): void => {
    if (typeof window === "undefined") return;

    localStorage.setItem(STORAGE_KEY, JSON.stringify(votes));
};

export const usePropertyVote = (propertyId: number, apiMessageIndex: number) => {
    const [currentVote, setCurrentVote] = useState<VoteType>(() => {
        const votes = getStoredVotes();
        const found = votes.find((v) => v.propertyId === propertyId);

        return found?.vote ?? null;
    });

    const handleVote = useCallback(
        (vote: "like" | "dislike") => {
            const votes = getStoredVotes();
            const index = votes.findIndex((v) => v.propertyId === propertyId);

            let finalVote: "like" | "dislike" | null = vote;

            if (index !== -1) {
                if (votes[index].vote === vote) {
                    votes.splice(index, 1);

                    setCurrentVote(null);
                    finalVote = null;
                } else {
                    votes[index].vote = vote;

                    setCurrentVote(vote);
                }
            } else {
                votes.push({propertyId, vote});

                setCurrentVote(vote);
            }

            saveVotes(votes);

            conversationalSearchResponseRatedHit(propertyId, finalVote, apiMessageIndex);
        },

        [propertyId, apiMessageIndex]
    );

    useEffect(() => {
        const votes = getStoredVotes();
        const found = votes.find((v) => v.propertyId === propertyId);

        setCurrentVote(found?.vote ?? null);
    }, [propertyId]);

    return {currentVote, handleVote};
};
